<template>
  <div>
    <span v-if="row.order">{{ row.order.refund_status }}</span>
    <span v-else-if="row.ccr_order">{{ row.ccr_order.is_refunded }}</span>
  </div>
</template>

<script>
export default {
  name: 'RefundStatus',
  components: { },
  props: {
    row: {
      type: Object,
      required: true
    },
    prop: {
      type: String,
      required: true
    }
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/coupon_codes/common/RefundStatus.vue